import styled from 'styled-components';

export const Form = styled.form`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Message = styled.div<{ $isError?: boolean }>`
  margin: 1.25rem 0 0.5rem;
  text-align: center;
  ${({ theme: { font } }) => font.t3};
  color: ${({ theme: { color }, $isError }) => ($isError ? color.ac11 : color.ui2)};
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormContainer = styled.div`
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  transition: width 0.5s ease-in 0s;
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 40px 80px 40px 80px;
  background: rgba(247, 247, 247, 0.7);
  display: flex;
  flex-direction: column;
  gap: 24px;
  scrollbar-color: rgb(196, 196, 196) transparent;
  scrollbar-width: thin;
`;

export const CommunicationPanelLogoArea = styled.div`
  display: flex;
  height: 82px;
  padding: 0px;
  color: ${({ theme }) => theme.color.ui2};
  justify-content: center;
`;
